export default __webpack_public_path__ + "638877671fd7d1bf4eb3f7ee79e66d7e.png";